enum EmissionTier {
  LOW = 'low',
  MODERATE = 'moderate',
  HIGH = 'high',
}

const emissionTierOptions: { name: EmissionTier; label: string }[] = [
  { name: EmissionTier.HIGH, label: 'High (+3.3 – 5.7°C)' },
  { name: EmissionTier.MODERATE, label: 'Medium (+2.1 – 3.5°C)' },
  { name: EmissionTier.LOW, label: 'Low (+1.3 – 2.4°C)' },
]

export function getPeriodYear(period: CanonicalPeriod): number {
  switch (period) {
    case CanonicalPeriod.SHORT_TERM:
      return 2030
    case CanonicalPeriod.MID_TERM:
      return 2050
    case CanonicalPeriod.LONG_TERM:
      return 2100
    default:
      console.error('Unknown period in getPeriodYear:', period)
      return 0
  }
}

enum CanonicalPeriod {
  SHORT_TERM = 'short',
  MID_TERM = 'mid',
  LONG_TERM = 'long',
}

export type CanonicalPeriodValue = 'short' | 'mid' | 'long'

const PERIODS: CanonicalPeriod[] = [CanonicalPeriod.SHORT_TERM, CanonicalPeriod.MID_TERM, CanonicalPeriod.LONG_TERM]

const canonicalPeriodLabels: { [key in CanonicalPeriod]: string } = {
  [CanonicalPeriod.SHORT_TERM]: 'Short Term (2030)',
  [CanonicalPeriod.MID_TERM]: 'Mid Term (2050)',
  [CanonicalPeriod.LONG_TERM]: 'Long Term (2100)',
}

enum MetricState {
  NO_RUN = 'no_run',
  QUEUED = 'queued',
  RUNNING = 'running',
  SUCCEEDED = 'succeeded',
  NO_DATA = 'no_data',
  FAILED = 'failed',
}

const metricStateLabels: { [key in MetricState]: string } = {
  [MetricState.NO_RUN]: 'Not Processed',
  [MetricState.QUEUED]: 'Queued',
  [MetricState.RUNNING]: 'Running',
  [MetricState.SUCCEEDED]: 'Succeeded',
  [MetricState.NO_DATA]: 'No Data',
  [MetricState.FAILED]: 'Failed',
}

const stateColorMapping: { [key in MetricState]: string } = {
  [MetricState.NO_RUN]: 'gray',
  [MetricState.QUEUED]: 'purple',
  [MetricState.RUNNING]: 'blue',
  [MetricState.SUCCEEDED]: 'green',
  [MetricState.NO_DATA]: 'orange',
  [MetricState.FAILED]: 'red',
}

export {
  EmissionTier,
  emissionTierOptions,
  CanonicalPeriod,
  PERIODS,
  canonicalPeriodLabels,
  MetricState,
  metricStateLabels,
  stateColorMapping,
}
export {
  ScoreBadge,
  createHazardScoreBadge,
  DEFAULT_SCORE_PALETTE,
  type ScoreBadgeSize,
  type ScorePalette,
  type HazardScoreBadgeProps,
} from './ScoreBadge'
